import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=7f0fb204&"
import script from "./ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0fb204')) {
      api.createRecord('7f0fb204', component.options)
    } else {
      api.reload('7f0fb204', component.options)
    }
    module.hot.accept("./ProjectDetails.vue?vue&type=template&id=7f0fb204&", function () {
      api.rerender('7f0fb204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/ProjectDetails.vue"
export default component.exports